export function sortResidencesByDate(
  a: { start_date?: string; end_date?: string | null },
  b: { start_date?: string; end_date?: string | null }
): number {
  if (!a.end_date && b.end_date) return -1;
  if (a.end_date && !b.end_date) return 1;
  if (!a.end_date && !b.end_date) return 0;

  const aStart = toSortableTimestamp(a.start_date);
  const bStart = toSortableTimestamp(b.start_date);
  if (aStart !== bStart) {
    if (aStart === null) return 1;
    if (bStart === null) return -1;
    return bStart - aStart;
  }

  const aEnd = toSortableTimestamp(a.end_date);
  const bEnd = toSortableTimestamp(b.end_date);
  if (aEnd !== bEnd) {
    if (aEnd === null) return 1;
    if (bEnd === null) return -1;
    return bEnd - aEnd;
  }

  return 0;
}

/**
 * Residence date fields are expected to be ISO-like strings. Invalid/missing
 * values are treated as unknown and sorted after valid historical dates.
 */
function toSortableTimestamp(dateValue?: string | null): number | null {
  if (!dateValue) return null;
  const timestamp = Date.parse(dateValue);
  return Number.isNaN(timestamp) ? null : timestamp;
}
